import { render, staticRenderFns } from "./ComplianceWorstPerformingElementsDrillDown.vue?vue&type=template&id=42a50b9c&"
import script from "./ComplianceWorstPerformingElementsDrillDown.vue?vue&type=script&lang=ts&"
export * from "./ComplianceWorstPerformingElementsDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports